import React, { useEffect } from "react";
import RouteNavigation from "./routes";
import { LanguageProvider } from "./context/LanguageContext";
import AOS from "aos";
import "aos/dist/aos.css";

function App() {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
  }, []);

  return (
    <div className="App">
      <LanguageProvider>
        <RouteNavigation />
      </LanguageProvider>
    </div>
  );
}

export default App;
